import PeepsAlertRight from '@/components/Core/Alerts/PeepsAlertRight'
import PeepsAlertAbove from '@/components/Core/Alerts/PeepsAlertAbove'
import PeepsAlertAnimation from './PeepsAlertAnimation'
import Vue from 'vue'

Vue.component('peeps-alert-left', PeepsAlertRight)
Vue.component('peeps-alert-above', PeepsAlertAbove)
Vue.component('peeps-alert-animation', PeepsAlertAnimation)
